<template>
  <div class="columns is-multiline is-main-content is-marginless is-paddingless"
       v-if="newCritereRecherche">
    <div class="column is-12 pdb-0 hauteur-haut-brief-filtre">
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('emplacement.filtre.title') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('emplacement.filtre.sousTitle') }}
        </span>
      </div>
    </div>
    <div class="column is-12 overflow-auto is-marginless hauteur-brief-filtre">
      <div class="column is-12 pdb-0">
        <b-field :label="$t('emplacement.filtre.codesEmplacement')">
          <qd-taginput v-model="newCritereRecherche.codes" type="is-primary">
          </qd-taginput>
        </b-field>
      </div>
       <div class="column is-12 pdb-0">
        <b-field :label="$t('emplacement.filtre.codesDispo')">
          <qd-taginput v-model="newCritereRecherche.codesDispo" type="is-primary">
          </qd-taginput>
        </b-field>
      </div>
       <div class="column is-12 pdb-0">
        <b-field :label="$t('emplacement.filtre.codesMateriel')">
          <qd-taginput v-model="newCritereRecherche.codesMateriel" type="is-primary">
          </qd-taginput>
        </b-field>
      </div>
       <div class="column is-12 pdb-0">
        <b-field :label="$t('emplacement.filtre.codesFace')">
          <qd-taginput v-model="newCritereRecherche.codesFace" type="is-primary">
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('emplacement.filtre.adresseEmplacement')">
          <b-input v-model="newCritereRecherche.adresseEmplacement">
          </b-input>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('emplacement.filtre.villeEmplacement')">
          <ville-tag-input-auto-complete
              :critere-recherche="newCritereRecherche"
              table-name="Emplacement"
              attribut="villesEmplacement"/>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('emplacement.filtre.agglomerationsEmplacement')">
          <qd-taginput v-model="newCritereRecherche.agglomerationsEmplacement" type="is-primary">
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('emplacement.filtre.adresseDispositif')">
          <b-input v-model="newCritereRecherche.adresseDispositif">
          </b-input>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('emplacement.filtre.villeDispositif')">
          <ville-tag-input-auto-complete
              :critere-recherche="newCritereRecherche"
              table-name="Emplacement"
              attribut="villesDispositif"/>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('emplacement.filtre.agglomerationsDispositif')">
          <qd-taginput v-model="newCritereRecherche.agglomerationsDispositif" type="is-primary">
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('emplacement.filtre.format')">
          <qd-taginput v-if="formatTags"
                      v-model="formatSelected"
                      :data="formatTags"
                      type="is-primary"
                      autocomplete
                      icon="magnify"
                      open-on-focus
                      field="libelle"
                      @typing="getFilteredFormatTags"
                      @input="getFormatTag">
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <libelle-tag-input
          :label="$t('emplacement.filtre.typeMateriel')"
          :items="materielTypeBase"
          field="libelle"
          v-model="materielTypeSelected">
        </libelle-tag-input>
    </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('emplacement.filtre.eclaire')">
          <b-select v-model="newCritereRecherche.eclaire">
            <option :value="null"></option>
            <option :value="true"> {{ $t('general.oui') }}
            </option>
            <option :value="false"> {{ $t('general.non') }}
            </option>
          </b-select>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <agence-tag-input
                      :label="$t('listeCollectivite.filtre.agence')"
                      :items="agencesSelectionnees"
                      v-model="newCritereRecherche.agencesId">
        </agence-tag-input>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
              @click="appliquerCritere()">
        {{ $t('emplacement.filtre.actions.appliquer') }}
      </button>

      <button @click="viderCritere()"
              class="button border-none mgt-10px has-text-icon-more pd-10px">
        {{ $t('emplacement.filtre.actions.reinitialiser') }}
      </button>
    </div>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import messageErreur from '@/services/general/messageErreur';
import genererCritereRechercheEmplacement from '@/services/gabed/emplacement/generer/genererCritereRechercheEmplacement';
import { createNamespacedHelpers } from 'vuex';
import VilleTagInputAutoComplete from '@/components/commun/ville/villeTagInputAutoComplete';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import agenceTagInput from '@/components/general/tagInput/agenceTagInput';
import libelleTagInput from '@/components/general/tagInput/libelleTagInput';

const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');

export default {
  components: {
    agenceTagInput,
    VilleTagInputAutoComplete,
    libelleTagInput,
  },
  data() {
    return {
      newCritereRecherche: null,
      listeFormatBase: null,
      formatTags: null,
      formatSelected: [],
      materielTypeSelected: [],
      materielTypeBase: [],
    };
  },
  props: {
    critereRecherche: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...Societe.mapGetters({
      agencesSelectionnees: 'agenceActive',
      societeActive: 'societeActive',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    appliquerCritere() {
      this.newCritereRecherche.formats = this.formatSelected.map(el => { return el.id; });
      this.newCritereRecherche.typesMateriels = this.materielTypeSelected.map(el => {
        return el.id;
      });
      this.$emit('recherche', this.newCritereRecherche);
    },
    viderCritere() {
      this.formatSelected = [];
      this.materielTypeSelected = [];
      this.newCritereRecherche = genererCritereRechercheEmplacement();
    },
    getFilteredFormatTags(text) {
      this.getFormatTag();
      this.formatTags = this.formatTags.filter((format) => {
        return format.libelle.toLowerCase().indexOf(text.toLowerCase()) >= 0;
      });
    },
    getFormatTag() {
      this.formatTags = this.listeFormatBase.filter((format) => {
        return !this.formatSelected.map(a => a.id).includes(format.id);
      });
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.newCritereRecherche = cloneDeep(this.critereRecherche);
      await this.loadParametres([PARAMETRES_KEYS.materielFormat,
        PARAMETRES_KEYS.materielType]);
      this.listeFormatBase = this.parametre(PARAMETRES_KEYS.materielFormat)
        .filter(el => el.actif);
      if (this.newCritereRecherche.formats) {
        this.formatSelected = this.listeFormatBase.filter((c) => {
          return this.newCritereRecherche.formats.includes(c.id);
        });
      }
      this.getFormatTag();

      this.materielTypeBase = this.parametre(PARAMETRES_KEYS.materielType)
        .filter(materielType => materielType.actif);
      if (this.newCritereRecherche.typesMateriels) {
        this.materielTypeSelected = this.materielTypeBase.filter((c) => {
          return this.newCritereRecherche.typesMateriels.includes(c.id);
        });
      }

      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
